

import React, { useContext } from 'react';
import UserContext from '../../context/Globales/UserContext';
import { v4 as uuid } from 'uuid';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableRow,
    makeStyles,
    TableHead,
    TableContainer,
    Grid,
    Modal, Fade, Backdrop, Button
} from '@material-ui/core';
import IcpdfDetalleVehiculos from '../pdf/IC/IcpdfDetalleVehiculos';



const useStyles = makeStyles((theme) => ({
    root: {},
    actions: {
        justifyContent: 'flex-end'
    },
    FondoTable: {
        backgroundColor: theme.palette.greyFondo.main, 
        textTransform: 'uppercase'
    },
    containerTable: {
        maxHeight: 290,

    },

    tituloTable: {

        backgroundColor: '#e6e6e6',
        minWidth: 200,
        color: 'Black',
        textAlign: 'center',
        padding: '10px',
        fontWeight: '250',
        fontSize: '16px'
    },
    modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
    },

    containerTable: {
        maxHeight: 290,

    },

}));
export const TblDetalleVehiculo = ({ className, rest }) => {
    const { DatodetalleVehiculos } = useContext(UserContext);
    const classes = useStyles();

    const [OpenModalpdfvehiculo, setOpenModalpdfvehiculo] = React.useState(false);

    const handlClikOpenModalvehiculopdf = () => {
        setOpenModalpdfvehiculo(!OpenModalpdfvehiculo);

    };


    return (

        <>


            {/*MODAL PDF INFORME COMER*/}

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modalPdf}
                open={OpenModalpdfvehiculo}
                onClose={handlClikOpenModalvehiculopdf}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 2000,
                }}>
                <Fade in={OpenModalpdfvehiculo}>

                    <div className={classes.paperPdf}>


                        <IcpdfDetalleVehiculos />



                    </div>

                </Fade>
            </Modal>


            <h4 className={classes.tituloTable}>Detalle de Vehiculo</h4>
            <br />
            {DatodetalleVehiculos && DatodetalleVehiculos != null ? <div style={{ alignContent: "center", textAlign: "center" }}><Button variant="contained" color="primary" onClick={handlClikOpenModalvehiculopdf}>Descargar PDF</Button></div> : ''}
            <br />

            <h2>{DatodetalleVehiculos && DatodetalleVehiculos == 'ERROR CONSULTA VEHICULO' ?
                'Error al procesar su solicitud, inténtelo mas tarde (INFORME COMERCIAL)' : ''}</h2>


            {DatodetalleVehiculos && DatodetalleVehiculos != null ? (

                <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>
                        <TableContainer className={classes.containerTable}>
                            <Table>
                                <TableHead className={classes.FondoTable}>
                                    <TableRow>
                                        <TableCell>Cant. de Vehiculos: {DatodetalleVehiculos && DatodetalleVehiculos.Vehiculos?.CantidadVehiculos} </TableCell>

                                    </TableRow>
                                </TableHead>


                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            ) : ''}
            { DatodetalleVehiculos &&  DatodetalleVehiculos != null  ? (

                <TableContainer className={classes.containerTable}>

                    <PerfectScrollbar>
                        <Box >
                            <Table size="small">
                                <TableHead className={classes.FondoTable}>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Marca</TableCell>
                                        <TableCell>Modelo</TableCell>
                                        <TableCell>Tipo</TableCell>
                                        <TableCell>Patente</TableCell>
                                        <TableCell>Año</TableCell>
                                        <TableCell>Color</TableCell>
                                        <TableCell>Ultima Transferencia</TableCell>
                                        <TableCell align="right" >Tasación</TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { DatodetalleVehiculos &&  DatodetalleVehiculos.Vehiculos?.DetalleVehiculos?.map((dvehiculo, idvehiculo) => (
                                        <TableRow

                                            key={uuid()}>
                                            <TableCell>{idvehiculo + 1}</TableCell>
                                            <TableCell>{dvehiculo.Marca}</TableCell>
                                            <TableCell>{dvehiculo.Modelo}</TableCell>
                                            <TableCell>{dvehiculo.Tipo}</TableCell>
                                            <TableCell>{dvehiculo.Patente}</TableCell>
                                            <TableCell>{dvehiculo.AgnoFabricacion}</TableCell>
                                            <TableCell>{dvehiculo.Color}</TableCell>
                                            <TableCell>{dvehiculo.UltimaTransferencia}</TableCell>
                                            {dvehiculo.Tasacion == '-' ? <TableCell align="right"> $0</TableCell> : <TableCell align="right">${dvehiculo.Tasacion}</TableCell>}






                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>

                    </PerfectScrollbar>
                </TableContainer>
            ) : <h4>Cargando información...</h4>}



        </>
    );
}
